var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              staticStyle: { "margin-top": "22px" },
              attrs: { "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "会员名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "232px" },
                    attrs: {
                      size: "small",
                      placeholder: "请输入会员名称",
                      disabled: "",
                    },
                    model: {
                      value: _vm.detail.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "name", $$v)
                      },
                      expression: "detail.name",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "有效期" } }, [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: {
                            size: "small",
                            placeholder: "请选择有效期",
                            disabled: "",
                          },
                          model: {
                            value: _vm.detail.expirationDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.detail, "expirationDate", $$v)
                            },
                            expression: "detail.expirationDate",
                          },
                        },
                        _vm._l(_vm.expireDates, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticStyle: { "margin-left": "32px" } }, [
                    _vm._v("购买价格"),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "16px" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "116px" },
                          attrs: { disabled: "", size: "small" },
                          model: {
                            value: _vm.detail.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.detail, "price", $$v)
                            },
                            expression: "detail.price",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { "margin-right": "8px" },
                              attrs: { slot: "suffix" },
                              slot: "suffix",
                            },
                            [_vm._v("元")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "会员介绍页" } }, [
                _c("div", {
                  staticClass: "detail",
                  domProps: { innerHTML: _vm._s(_vm.detail.introduce) },
                }),
              ]),
              _c("el-form-item", { attrs: { label: "会员状态" } }, [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c("div", {
                    class: _vm.detail.status == 1 ? "start" : "end",
                  }),
                  _vm.detail.status == 1
                    ? _c("div", { staticClass: "s-label" }, [_vm._v("已启用")])
                    : _c("div", { staticClass: "s-label" }, [_vm._v("已禁用")]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "back-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }